import React from "react";
import { useStringOrNull } from "providers/LocalisationProvider";

export const InvalidUser = ({ error }) => {
  return <p className="text-danger">{useStringOrNull(error)}</p>;
};
